import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import * as XLSX from 'xlsx';

const FarmerSurveyReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [farmerSurveyTemplateId, setFarmerSurveyTemplateId] = useState();
  const [templateDetail, setTemplateDetail] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getProcurementTemplateData } = useHttp();

  const fillProcurementTemplateData = (employeeId, templateName) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (templateName != "") {
      urlfilter = urlfilter + `&templateName=${templateName}`;
    }

    getProcurementTemplateData(
      {
        url: `/api/farmerSurveyReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter} `,
      },
      (data) => {
        // console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillProcurementTemplateData(0, 0, "");
  }, [getProcurementTemplateData]);

  const dynamicHeaders =
    templateDetail.surveyQuestionList?.map((itm) => itm.surveyQuestion) || [];
    // console.log("dynamicHeaders",dynamicHeaders)

  const handleExportExcel = () => {
    const filename = "FarmerSurveyReport.xlsx";

    const dataToExport = data.map((itm) => {
      const staticData = {
        surveyDate: itm.surveyDate,
        templateName: itm.templateName,
        typeOfFarming: itm.typeOfFarming,
        farmerName: itm.farmerName,
        mobileNumber: itm.mobileNumber,
        address: itm.address,
        country: itm.country,
        state: itm.state,
        city: itm.city,
        village: itm.village,
        createdDate: itm.createdDate,
      };
  
      const dynamicData = itm.surveyDetails.reduce((acc, detail) => {
        acc[detail.surveyQuestion] = detail.answers.flat().join(", ");
        return acc;
      }, {});
  
      return { ...staticData, ...dynamicData };
    });
  
    // console.log("Data to Export:", dataToExport);
  
    const customHeaders = [
      "Date",
      "Template Name",
      "Farmer Type",
      "Farmer Name",
      "Mobile",
      "Address",
      "Country",
      "State",
      "City",
      "Village",
      ...dynamicHeaders,
      "Created Date",
    ];
  
    const headerKeyMap = {
      Date: "surveyDate",
      "Template Name": "templateName",
      "Farmer Type": "typeOfFarming",
      "Farmer Name": "farmerName",
      Mobile: "mobileNumber",
      Address: "address",
      Country: "country",
      State: "state",
      City: "city",
      Village: "village",
      "Created Date": "createdDate",
    };
  
    convertToExcel(dataToExport, customHeaders, headerKeyMap, filename);
  };
  
  const convertToExcel = (data, headers, headerKeyMap, filename) => {
    const worksheetData = data.map((row) => {
      return headers.map((header) => row[headerKeyMap[header] || header] || "NA");
    });
  
    // Add headers as the first row
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...worksheetData]);
  
    // Calculate column widths based on the header text length
    const colWidths = headers.map((header) => ({
      wch: Math.max(header.length + 5, 10), // Add some padding for readability
    }));
  
    // Apply column widths to the worksheet
    worksheet["!cols"] = colWidths;
  
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, "Survey Data");
  
    // Write the Excel file to the browser
    XLSX.writeFile(wb, filename);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: gettemplate } = useHttp();
  useEffect(() => {
    gettemplate(
      {
        url: `/api/farmerSurveyTemplate/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // console.log("setTemplateList", data);
        if (data) {
          setTemplateList(data);
        }
      }
    );
  }, [gettemplate]);

  const { sendRequest: getTemplateDetail } = useHttp();

  const FillTemplateDetail = (farmerSurveyTemplateId) => {
    var urlfilter = "";

    getTemplateDetail(
      {
        url: `/api/farmerSurveyTemplate/?farmerSurveyTemplateId=${farmerSurveyTemplateId}&orgId=${localStorage.getItem(
          "orgId"
        )} `,
      },
      (data) => {
        // console.log("emp", data);

        setTemplateDetail(data);
      }
    );
  };
  useEffect(() => {
    FillTemplateDetail(0);
  }, [getTemplateDetail]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Survey Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Template Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={farmerSurveyTemplateId}
                    onChange={(e) => {
                      var selectedId = 0;
                      if (e.target.value != "--Select--")
                        selectedId = e.target.value;

                      setFarmerSurveyTemplateId(selectedId);
                      FillTemplateDetail(selectedId);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {templateList &&
                      templateList.map((x) => (
                        <option
                          key={x.farmerSurveyTemplateId}
                          user-id={x.farmerSurveyTemplateId}
                          value={x.farmerSurveyTemplateId}
                        >
                          {x.templateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillProcurementTemplateData(employeeId, templateName);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-lg">
                      <thead>
                        <tr className="table-header">
                          <th>Date</th>
                          <th>Template Name</th>
                          <th>Farmer Type</th>
                          <th>Farmer Name</th>
                          <th>Mobile</th>
                          <th>Address</th>
                          <th>Country</th>
                          <th>State</th>
                          <th>City</th>
                          <th>Village</th>
                          {templateDetail.surveyQuestionList?.map((itm, i) => {
                            return <th>{itm.surveyQuestion}</th>;
                          })}
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.surveyDate}</td>
                                <td>{itm.templateName}</td>
                                <td>{itm.typeOfFarming}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.mobileNumber}</td>
                                <td>{itm.address}</td>
                                <td>{itm.country}</td>
                                <td>{itm.state}</td>
                                <td>{itm.city}</td>
                                <td>{itm.village}</td>
                                {templateDetail.surveyQuestionList?.map(
                                  (question, qIndex) => {
                                    const answerDetail = itm.surveyDetails.find(
                                      (detail) =>
                                        detail.farmerSurveyTemplateQuestionId ===
                                      question.farmerSurveyTemplateQuestionId
                                    );
                                    return (
                                      <td key={qIndex}>
                                        {answerDetail?.answers
                                          ? String(
                                            answerDetail.answers
                                          ).replace(/\s*,\s*/g, ", ")
                                          : "N/A"}
                                      </td>
                                    );
                                  }
                                )}
                                <td>{itm.createdDate}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerSurveyReport;
